// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"053b6d4d","496":"409d6545"}[chunkId] + ".chunk.js";
};